<template>
  <fieldset class="fieldset">
    <legend class="legend" :class="requiredClass">
      <slot name="legend"></slot>
    </legend>
    <transition-group class="check-list"
                      name="accordion" move-class="accordion-move" tag="ul">
      <li class="check-list-item" v-for="item in visibleItems" :key="item.id">
        <label class="label">
          <input class="checkbox" type="checkbox"
                                  :value="item.id"
                                  :name="inputName"
                                  v-model="checkedItems"
                                  @change="onCheckboxChange">
          <span class="pseudo-checkbox">{{ customLabel(item[labelProp]) }}</span>
        </label>
      </li>
    </transition-group>

    <button class="more" type="button"
                         v-if="showItemIds.length < items.length" @click="accordion('item')">
      <slot name="more"></slot>
    </button>
  </fieldset>
</template>

<script>

export default {
  name: 'ChecklistField',

  props: {
    modelValue: {
      type: Array,
      default: function () { return [] }
    },

    inputName: {
      type: String,
      required: true
    },

    items: {
      type: Array,
      default: () => []
    },

    // items を表示する数
    // items が指定数以上の時はアコーディオンで隠す
    // 0 を指定すると全部表示する
    minCount: {
      type: Number,
      default: 0
    },

    // ラベルに表示するプロパティ
    labelProp: {
      type: String,
      required: false,
      default: 'label'
    },

    // 必須項目か
    required: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue', 'change'],

  data: function () {
    return {
      checkedItems: this.modelValue,
      showItemIds: [],
      open: false
    }
  },

  computed: {
    // Vue 3: v-if + v-for on same element causes v-if to win (item undefined → crash)
    // Fix: filter items via computed to separate the concerns
    visibleItems () {
      return this.items.filter(item => this.showItemIds.indexOf(item.id) !== -1)
    },

    requiredClass: function () {
      const className = this.required ? 'required' : 'elective'

      const result = {}
      result[className] = true

      return result
    }
  },

  watch: {
    items: function () {
      const shownItemIds = this.showItemIds.concat()  // copy array

      if (this.open) {
        this.items.map((item) => {
          if (shownItemIds.indexOf(item.id) === -1) {
            this.showItemIds.push(item.id)
          }
        })

        return
      }

      if (this.showItemIds.length < this.minCount) {
        this.items.map((item) => {
          if (this.minCount <= this.showItemIds.length) {
            return
          }

          if (shownItemIds.indexOf(item.id) === -1) {
            this.showItemIds.push(item.id)
          }
        })
      }
    }
  },

  created: function () {
    // アコーディオンはデフォルトでオープン
    if (this.minCount === 0) {
      this.open = true
    }
  },

  methods: {
    onCheckboxChange () {
      this.$emit('update:modelValue', this.checkedItems)
      this.$emit('change', this.checkedItems)
    },

    // 隠している要素を表示する
    accordion: function () {
      const shownItemIds = this.showItemIds.concat()  // copy array

      this.items.map((item) => {
        if (shownItemIds.indexOf(item.id) === -1) {
          this.showItemIds.push(item.id)
        }
      })

      this.open = true
    },

    // 201903 実施のテストのため場当たり的な実装になっています
    // 201904 には結果を見た上で、新昨日開発 or 削除の対応が必要
    // Issue https://github.com/basicinc/ryugaku-kuraveil/issues/2161
    customLabel: function (label) {
      if (label === 'その他英語圏') {
        const url = document.referrer
        switch (true) {
          case /fiji/.test(url): return 'フィジー'
          case /malta/.test(url): return 'マルタ'
          case /philippines/.test(url): return 'フィリピン'
          case /guam/.test(url): return 'グアム'
          case /singapore/.test(url): return 'シンガポール'
        }
      }
      return label
    }
  }
}
</script>
